import { useMediaPredicate } from 'react-media-hook'

import { theme } from '../../lib/theme'
import { ScreenDeviceType } from '../enums/screenDeviceTypeEnum'

export default function useMediaQueryHook() {
    const isMobileScreen = useMediaPredicate(`only screen and (max-width: ${theme.breakPoints.sm})`)
    const isTabletScreen = useMediaPredicate(
        `only screen and (min-width : ${theme.breakPoints.sm}) and (max-width : ${theme.breakPoints.md})`
    )
    const isDesktopScreen = useMediaPredicate(
        `only screen and (min-width : ${theme.breakPoints.md}) and (max-width : ${theme.breakPoints.lg})`
    )

    if (isMobileScreen) {
        return ScreenDeviceType.Mobile
    } else if (isTabletScreen) {
        return ScreenDeviceType.Tablet
    } else if (isDesktopScreen) {
        return ScreenDeviceType.Desktop
    } else {
        return ScreenDeviceType.DesktopXL
    }
}
